import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/marketplace/pages/publicMarketplacePage.tsx");
